/** @format */

import React, { useState } from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import { FaMapMarkedAlt } from "react-icons/fa";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export function CardLoja({ props, onClick }) {
  const [verMais, setVerMais] = useState(false);

  const {
    nome,
    endereco,
    telefone,
    whatsapp,
    celular,
    complemento,
    funcionamentoloja,
    distancia,
    distanciaFormatada,
  } = props;

  return (
    <HStack
      cursor="pointer"
      spacing="1rem"
      alignItems="flex-start"
      _hover={[{ filter: "brightness(0.98)", background: "#fafafa" }]}>
      <Box display="flex" flexDir="column" alignItems="center">
        <FaMapMarkedAlt color="#DC7209" size={56} />
        <Text
          textAlign="center"
          fontSize="sm"
          fontWeight="medium"
          color="#3E4047">
          {distancia === "0 " ? null : distanciaFormatada}
        </Text>
      </Box>
      <Box
        wordBreak="break-word"
        display="flex"
        flexDir="column"
        justifyContent="space-between"
        alignItems="flex-start">
        <Box onClick={onClick}>
          <Text fontWeight="semibold" fontSize="sm" color="#3E4047">
            {nome}
          </Text>
          <Text fontWeight="normal" fontSize="sm" color="#70747D">
            {endereco}
          </Text>
          {telefone && (
            <Text fontWeight="normal" fontSize="sm" color="#3E4047">
              Telefone: {telefone}
            </Text>
          )}
          {!verMais && complemento && (
            <Text fontWeight="normal" fontSize="sm" color="#3E4047">
              Complemento: {complemento}
            </Text>
          )}
          {verMais && (
            <>
              {celular && (
                <Text fontWeight="normal" fontSize="sm" color="#3E4047">
                  Celular: {celular}
                </Text>
              )}
              {whatsapp && (
                <Text fontWeight="normal" fontSize="sm" color="#3E4047">
                  Whatsapp: {whatsapp}
                </Text>
              )}
              <Box h="0.5rem"></Box>
              {complemento && (
                <Text fontWeight="normal" fontSize="sm" color="#3E4047">
                  Complemento: {complemento}
                </Text>
              )}
              {funcionamentoloja && (
                <Text fontWeight="normal" fontSize="sm" color="#3E4047">
                  {funcionamentoloja}
                </Text>
              )}
            </>
          )}
        </Box>
        {(funcionamentoloja || celular || whatsapp) &&
          (!verMais ? (
            <FiChevronDown size={20} onClick={() => setVerMais(true)} />
          ) : (
            <FiChevronUp size={20} onClick={() => setVerMais(false)} />
          ))}
      </Box>
    </HStack>
  );
}
